
@switch (status) {
  @case ('active') {
    <span class="status active">
      <i class="fas fa-check"></i>
      {{activeText}}
    </span>
  }
  @case ('error') {
    <span class="status error">
      <i class="fas fa-times"></i>
      {{errorText}}
    </span>
  }
  @case ('warning') {
    <span class="status warning">
      <i class="fas fa-times"></i>
      {{warningText}}
    </span>
  }
}
